export default __webpack_public_path__ + "static/media/i_bus-low_bl.47ff80e3.svg";